import { IconProps } from '@/components/svg/study-icon'

export const MockTestIcon: React.FC<IconProps> = ({ size = 20, className, ...rest }) => (
    <svg
        width={size}
        height={size}
        viewBox='0 0 20 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className={className}
        {...rest}
    >
        <path
            d='M13.02 16.52C10.679 17.256 8.02 17.126 5.7 16L1 17L2.3 13.1C-0.0239997 9.663 0.874 5.228 4.4 2.726C7.926 0.224997 12.99 0.429997 16.245 3.206C17.894 4.613 18.82 6.459 18.987 8.358M17 19V19.01M17 16C17.4483 15.9986 17.8832 15.8468 18.235 15.569C18.5868 15.2911 18.8352 14.9033 18.9406 14.4675C19.0459 14.0318 19.0019 13.5733 18.8158 13.1655C18.6297 12.7576 18.3122 12.424 17.914 12.218C17.5162 12.0142 17.0611 11.951 16.6228 12.0387C16.1845 12.1264 15.7888 12.3598 15.5 12.701'
            stroke='currentColor'
            strokeWidth={1.5}
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
)